import { styled } from "styled-components";

import type { FontVariant } from "@similarweb/styles";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import type { TitleSizes } from "./TitleWithInfo";

export const Container = styled(Flex)<{ size?: TitleSizes }>`
    align-items: center;
    gap: ${({ size = "large" }) => {
        switch (size) {
            case "medium":
                return "4px";
            case "large":
                return "8px";
            default:
                return "8px";
        }
    }};

    .SWReactIcons {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const Title = styled.h6<{ size?: TitleSizes; fontVariant?: FontVariant }>`
    ${({ size = "large", fontVariant }) => {
        switch (size) {
            case "medium":
                return setFontVariant(fontVariant ?? "body1", colorsPalettes.carbon[500]);
            case "large":
                return setFontVariant(fontVariant ?? "h6", colorsPalettes.carbon[500]);
            default:
                return setFontVariant("h6", colorsPalettes.carbon[500]);
        }
    }}
    margin: 0;
`;
